//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { CACHE_SETTINGS } from '~/utils/cache'
import { getLocations } from '~/utils/server'
import TheMostPopular from '~/components/section/selection/the-most-popular'
import numberWithCommas from '~/filters/numberWithCommas'
import toLowerCaseFilter from '~/filters/toLowerCase'
import capitalizeFirstLetterFilter from '~/filters/capitalizeFirstLetter'
import PageTop from '~/components/section/page-top.vue'
import SearchOtherBoatTypes from '~/components/search/page/search-other-boat-types.vue'
import SearchComponent from '~/components/search/page/search-component.vue'

export default {
  name: 'BoatTypePage',
  filters: {
    numberWithCommas,
    capitalizeFirstLetterFilter,
    toLowerCaseFilter
  },
  components: {
    SearchComponent,
    PageTop,
    TheMostPopular,
    OffersInMailbox,
    SearchOtherBoatTypes
  },
  mixins: [pageMeta],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'boat_type',
          path: ctx.route.path,
          idx: ctx.route.params.boatType
        }
      })
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = ietfLocale || 'en-gb'

      const page = {}

      page.boatType = await ctx.$cacheFetch({
        key: `data/getBoatType?locale=${lang}&slug=${ctx.route.params.boatType}`, expire: CACHE_SETTINGS.baseTime
      }, async () => {
        const fetchBoatTypeRequest = {
          query: `query FetchBoatTypes($shortcode: String!, $slug: [String]) {
                      boatTypes(slug: $slug) {
                        id
                        in_search_bar
                        is_page
                        order_by
                        top_image
                        values(shortcode: $shortcode) {
                          name
                          plural_name
                          slug
                          search_slug
                          description
                          language {
                            shortcode
                          }
                        }
                      }
                    }`,
          variables: { shortcode: lang, slug: [ctx.route.params.boatType] }
        }

        const resp = await ctx.$axios.post('/api/graphql/query', fetchBoatTypeRequest)
        const boatTypes = resp.data.data.boatTypes.map((t) => {
          return {
            ...t,
            values: t.values.map((v) => {
              return {
                ...v,
                db_slug: v.slug,
                slug: v.search_slug
              }
            })
          }
        })
        return boatTypes[0]
      })

      if (!page.boatType || !page.boatType.is_page) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'destinations' }).href)
        // return ctx.error({ statusCode: 404, message: 'Page not found' })
      }

      const current = page.boatType?.values.find(i => i.language.shortcode === lang)
      if (current) {
        page.boatType = { ...page.boatType, ...current }
      }

      page.boatType = {
        ...page.boatType,
        plural_name: page.boatType?.plural_name || page.boatType.name
      }

      if (page.boatType.db_slug && (ctx.route.params.boatType !== page.boatType.db_slug)) {
        ctx.redirect({
          name: 'boat-type', params: { lang, boatType: page.boatType.db_slug }
        })
        return
      }

      const mostPopLocations = await ctx.$cacheFetch({
        key: `pIndex-getLocations?locale=${lang}`, expire: CACHE_SETTINGS.baseTime
      }, async () => {
        return await getLocations(ctx, {
          lang,
          ietf,
          locationType: [
            { id: 'popular' }
          ],
          locationLimit: {
            default: 10,
            popular: 8
          },
          boatType: page.boatType.id
        })
      })

      await ctx.store.dispatch('auth/getFavorites')

      await ctx.store.commit('page/SET_BOAT_TYPE_PAGE', page)

      return {
        mostPopLocations: mostPopLocations.popular,
        renting: ctx.store.getters['data/boatFormData'].rentingOptions
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      page: {
        sticky: false
      }
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      pageSeoData: state => state.pageData,
      destinationData: state => state.search.destination,
      loading: state => state.search.loading,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      results: state => state.search.results,
      amountResultsFound: state => state.search.amountResultsFound,
      locations: state => state.search.locations,
      hasBeenFiltered: state => state.search.hasBeenFiltered,
      pagination: state => state.search.pagination,
      staticReviews: 'staticReviews'
    }),
    ...mapGetters({
      bar: 'search/bar',
      locale: 'lang/locale',
      boatTypePage: 'page/boatTypePage',
    }),
    boatType () {
      return this.boatTypePage.boatType
    },
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? this.$t(t?.name?.toLowerCase()) : t?.name
        }
      })
    },
    getBoatType () {
      return this.boatTypePage?.boatType
    },
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'popular-destination': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            arrows: false,
            slidesToShow: 'auto',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    },
    getBoatTypeName () {
      return this.boatTypePage?.boatType?.name || ''
    },
    boatTypeText () {
      return this.boatTypePage?.boatType?.description
    },
    getTopImage () {
      return this.boatTypePage?.boatType?.top_image
    },
    getShowAllButton () {
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    }
  },
  mounted () {
    this.createdMethod()
    this.$scrollTo({ y: 0 })
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  },
  beforeDestroy () {
    this.$store.commit('search/RESET_FILTERS_SHOW_LIMITS')
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', 'croatia')
      this.$Search.setAttributeValue('limit_date', false)
      this.$Search.setAttributeValue('boat_types', [this.getBoatType.id])
      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    }
  },
  jsonld () {
    const reviewListItems = this.staticReviews.map((review) => {
      return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: 'Tubber',
        review: {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
            bestRating: 5,
            worstRating: 1
          },
          name: this.$t(review.title),
          author: {
            '@type': 'Person',
            name: this.$t(review.user_name)
          },
          reviewBody: this.$t(review.review_text)
        }
      }
    })
    return {
      name: 'Tubber',
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: reviewListItems
    }
  }
}
